const Price = {
  format: (locale, currency, amount) => {
    return `€${parseInt(amount, 10)}`
  }
}

export default Price